import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Driver_Icon from "../../images/drivers/Driver_icon.svg";

export default function PhotoUploadBox({ onImageUpload }) {
    const [preview, setPreview] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            onImageUpload(file);
            
            // Create a preview URL for the selected image
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreview(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <Box sx={{ position: 'relative' }}>
            <Box
                sx={{
                    border: '2px dashed #183059',
                    borderRadius: '50%',
                    backgroundColor: "#E8EAEE",
                    height: '200px',
                    width: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    cursor: 'pointer',
                    overflow: 'hidden'
                }}
            >
                {preview ? (
                    <img 
                        src={preview} 
                        alt="Preview" 
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                ) : (
                    <img src={Driver_Icon} alt='driver icon'/>
                )}

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: 0,
                        cursor: 'pointer',
                    }}
                    id="profile-upload-input"
                />
            </Box>
            
            {/* Edit/Pen Icon - Only shown when a photo is uploaded */}
            {preview && (
                <IconButton 
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 20,
                        backgroundColor: '#183059',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: '#122442',
                        },
                        width: '40px',
                        height: '40px',
                        zIndex: 10
                    }}
                    component="label"
                    htmlFor="profile-upload-input"
                >
                    <EditIcon fontSize="small" />
                </IconButton>
            )}
        </Box>
    );
}